import React from 'react';
import { isExtensionInstalled } from '../../utils/tiptap';
import s from './buttons.scss';
const Separator = ({ hideWhen, editor })=>{
    if (hideWhen && !isExtensionInstalled(editor, hideWhen)) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: s['separator']
    }, /*#__PURE__*/ React.createElement("div", null));
};
Separator.displayName = 'Separator';
export default Separator;

//# sourceMappingURL=Separator.js.map